const getDashboardWavePreviewUrl = (waveId) =>
  `${process.env.REACT_APP_DASHBOARD_WAVE_PREVIEW_URL}/${waveId}`;

export default getDashboardWavePreviewUrl;
